export const SETTINGS_DRAWERS = {
  BUSINESS_HOURS: 'businessHoursDrawer',
};
